import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/svg/shevron_2.svg'
import _imports_1 from '@/assets/svg/shevron_1.svg'


const _hoisted_1 = { class: "flex flex-col w-full" }
const _hoisted_2 = { class: "list-disc pl-10" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-[22px]"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "w-[22px]"
}

import { withDefaults, ref, toRefs } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseLine from '@/components/common/BaseLine.vue';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAccordion',
  props: {
    title: {},
    expanded: { type: Boolean, default: false },
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { isMobile } = toRefs(useGlobalStore());
const isExpanded = ref<boolean>(props.expanded);
const changeExpanded = () => {
    if (!props.disabled) {
        isExpanded.value = !isExpanded.value;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex justify-between w-full mb-3", { 'cursor-pointer': !_ctx.disabled }]),
      onClick: changeExpanded
    }, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _ctx.title,
              type: _unref(isMobile) ? 'body-m' : 'body'
            }, null, 8, ["text", "type"])
          ])
        ])
      ]),
      (isExpanded.value && !_ctx.disabled)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      (!isExpanded.value && !_ctx.disabled)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(BaseLine),
    _withDirectives(_createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, isExpanded.value]
    ])
  ]))
}
}

})